import type { SVGProps } from "react";

const SvgSpardaSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="41.0 41.0 430.0 430.0"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path fill="#900" d="M41 41h430v430H41z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M243.147 73.938V438.98l92.448-182.096zm-9.88 365.042V217.675l-55.949 110.443z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSpardaSmallLogo;
